import React, { useRef, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { isDefault, isThankYouLotto } from '../../../../utils/template';

import LotteryPermsPicker from '../PermsAndBankers/LotteryPermsPicker';

import DesktopPicker from './DesktopPicker';
import MobilePicker from './MobilePicker';

import useIsMobileUpdater from 'components/play/elements/useIsMobileUpdater';
import { setDesktopRowSize } from 'components/play/redux/lotteryStoreSlice';
import { RootState } from 'components/play/redux/store';

function LotteryPicker() {
    const dispatch = useDispatch();
    const { lottery, isMobile } = useSelector((state: RootState) => state.playStore);
    const child = useRef<HTMLDivElement>();
    const { desktopRowSize } = useSelector((state: RootState) => state.lotteryPlayStore);

    const handleResize = (currentIsMobile: boolean) => {
        if (!currentIsMobile && child.current?.firstElementChild) {
            const width = child.current.getBoundingClientRect().width;
            const panelWidth = child.current.firstElementChild.getBoundingClientRect().width;
            const rowSize = Math.floor(width / Math.floor(panelWidth));

            dispatch(setDesktopRowSize(rowSize));
        }
    };

    useEffect(() => handleResize(isMobile), [isMobile]);

    useIsMobileUpdater(handleResize);

    const renderPicker = () => {
        switch (true) {
            case lottery.lotteryRule.is_perms_enabled:
                return <LotteryPermsPicker />;
            case isMobile || isDefault():
                return <MobilePicker />;
            default:
                return <DesktopPicker ref={child} rowSize={desktopRowSize} />;
        }
    };

    const isTemplateThankYouLotto = useMemo(() => isThankYouLotto(), []);
    if (isTemplateThankYouLotto) {
        return renderPicker();
    }

    return (
        <div className="row row-picker no-gutters d-flex user-guide-play-picker">
            <div className="purchase w-100 play-base-type">{renderPicker()}</div>
        </div>
    );
}

export default LotteryPicker;
